import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ViewController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { AppConfig } from "../../providers/config";
import * as moment from "moment";
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';

@IonicPage()
@Component({
  selector: 'page-admin-users-add',
  templateUrl: 'admin-users-add.html',
})
export class AdminUsersAddPage {
  user: any = {};
  clinic_selected: any = {};
  public clinicList: Observable<any[]>;

  first_name: FormControl;
  last_name: FormControl;
  email: FormControl;
  phone_number: FormControl;
  password: FormControl;
  clinic: FormControl;
  opteva_admin: FormControl;
  clinic_tester: FormControl;
  clinic_admin: FormControl;

  constructor(public viewCtrl: ViewController, private database: DatabaseProvider, public params: NavParams, public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, private auth: AuthProvider, public loadingCtrl: LoadingController) {
    this.clinicList = params.get('clinics'); 

    this.auth.getUserToken().then((token) => {
      // console.log('User Token: ', token);
    });

    this.first_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.last_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.email = new FormControl(
      "",
      Validators.compose([
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")
      ])
    );
    this.password = new FormControl(
      "",
      Validators.compose([
        Validators.minLength(8),
        Validators.maxLength(30),
        Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"),
        Validators.required
      ])
    );
    this.phone_number = new FormControl("", Validators.required);
  this.clinic = new FormControl("");

    this.user = formBuilder.group({
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      phone_number: this.phone_number,
      password: this.password,
      opteva_admin: this.opteva_admin,
      clinic_admin: this.clinic_admin,
      clinic_tester: this.clinic_tester,
      clinic: this.clinic
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminUsersAddPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  showClinic(ev, clinic)  {
    console.log('clinic event: ', ev);
    console.log('clinic: ', clinic);
    this.clinic_selected = clinic;
  }
  createUser()  {
    let new_user = this.user.value;
    new_user['clinic_patient'] = 'false';
    new_user['clinic_id'] = this.clinic_selected.id;
    new_user['clinic_name'] = this.clinic_selected.clinic_name;
    if(new_user['opteva_admin'] === null) new_user['opteva_admin'] = false;
    if(new_user['clinic_tester'] === null) new_user['clinic_tester'] = false;
    if(new_user['clinic_admin'] === null) new_user['clinic_admin'] = false;
    if(new_user['clinic_patient'] === null) new_user['clinic_patient'] = false;
    console.log('Creating new user: ', new_user);
    const loader = this.loadingCtrl.create({
      content: "Creating User..."
    });

    loader.present()
    this.database.createUser(new_user).then((result) => {
      loader.dismiss().then(() => {
        console.log('create user: ', result);
        this.dismiss();
      })
      

    })
    .catch((error) => {
      loader.dismiss();
      console.log('create user error: ', error);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-users-add/admin-users-add.ts